import { createEntityAdapter } from '@reduxjs/toolkit'

import { Field } from 'common/fields/entities/field'
import { FilterScenario } from 'common/filter/interfaces'

export const fieldsAdapter = createEntityAdapter<Field>()

export type FieldsToScenario = Partial<Record<FilterScenario | 'default', Array<Field['id']>>>

export type ScenarioState = {
  isFetching: boolean
  isInitialized: boolean
}

type StateByScenario = Partial<Record<FilterScenario | 'default', ScenarioState>>

export const initialState = fieldsAdapter.getInitialState<{
  fetching: boolean
  initialized: boolean
  fieldsToScenario: FieldsToScenario
  stateByScenario: StateByScenario
}>({
  fetching: false,
  initialized: false,
  fieldsToScenario: {},
  stateByScenario: {},
})

export type FieldsState = typeof initialState
